export const main_url = document.location.hostname == 'localhost' ? 'https://shopiles.remi-zehr.dev.oliv.fr' : ''
export const get_nosecure = document.location.hostname == 'localhost' ? '?nosecure' : ''